import { createContext, useContext, useState } from 'react';

const BriefLiveContext = createContext();

const initialState = {
  selectedTab: 'talking-point',
};

const BriefLiveProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));

  return <BriefLiveContext.Provider value={{ state, updateState }}>{children}</BriefLiveContext.Provider>;
};

export const useBriefLiveState = () => {
  return useContext(BriefLiveContext);
};

export default BriefLiveProvider;
